import { render } from "./v-pagination.vue?vue&type=template&id=5c935592&scoped=true"
import script from "./v-pagination.vue?vue&type=script&lang=js"
export * from "./v-pagination.vue?vue&type=script&lang=js"

import "./v-pagination.vue?vue&type=style&index=0&id=5c935592&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c935592"]])

export default __exports__